import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { exhaustMap, of } from 'rxjs';
import { CommonService, FileManagerTipologieService } from '../../../api/services';
import { concatLatestFrom, mapResponse } from '@ngrx/operators';
import { LoadingState } from '../models/loader.model';
import { commonActions } from './common.actions';
import { Store } from '@ngrx/store';
import { commonSelectors } from './common.selectors';
import { getErrorMessage, ZetraError } from '../../shared/errors/error-messages.helper';

export const countriesLoadEffect = createEffect(
  (actions$ = inject(Actions), commonService = inject(CommonService), store = inject(Store)) => {
    return actions$.pipe(
      ofType(commonActions.loadCountries),
      concatLatestFrom(() => store.select(commonSelectors.countries)),
      exhaustMap(([action, countries]) => {
        return countries.state.value !== LoadingState.SUCCESS
          ? commonService.commonControllerFindCountries().pipe(
              mapResponse({
                next: (r) =>
                  commonActions.doneLoadCountries({ data: r.data.list, state: { value: LoadingState.SUCCESS } }),
                error: (error: ZetraError) =>
                  commonActions.doneLoadCountries({
                    state: {
                      value: LoadingState.FAIL,
                      message: { severity: 'warn', text: getErrorMessage(error.errorCode) },
                    },
                  }),
              }),
            )
          : of(commonActions.doneLoadCountries({ data: countries.data!, state: { value: LoadingState.SUCCESS } }));
      }),
    );
  },
  { functional: true },
);

export const mediaTypesLoadEffect = createEffect(
  (actions$ = inject(Actions), mediaTypeService = inject(FileManagerTipologieService), store = inject(Store)) => {
    return actions$.pipe(
      ofType(commonActions.loadMediaTypes),
      concatLatestFrom(({ entity }) => store.select(commonSelectors.mediaTypes(entity))),
      exhaustMap(([action, mediaTypes]) => {
        return !mediaTypes || mediaTypes.state.value !== LoadingState.SUCCESS
          ? mediaTypeService
              .mediaTypeControllerFindAll({
                entity: action.entity,
              })
              .pipe(
                mapResponse({
                  next: (r) =>
                    commonActions.doneMediaTypes({
                      entity: action.entity,
                      data: r.data.list,
                      state: { value: LoadingState.SUCCESS },
                    }),
                  error: (error: ZetraError) =>
                    commonActions.doneMediaTypes({
                      entity: action.entity,
                      state: {
                        value: LoadingState.FAIL,
                        message: { severity: 'warn', text: getErrorMessage(error.errorCode) },
                      },
                    }),
                }),
              )
          : of(
              commonActions.doneMediaTypes({
                entity: action.entity,
                data: mediaTypes.data!,
                state: { value: LoadingState.SUCCESS },
              }),
            );
      }),
    );
  },
  { functional: true },
);
